module.exports = __webpack_public_path__ + "f.no2.9a161fde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/f.no2.jpg
// module id = fuXN
// module chunks = 0